import React, { useEffect, useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { setIsLoading, login } from '../general/actions';
import ResetPassword from './resetPassword';
import axiosInstance, { ensureCsrfCookie } from '../general/axiosInstance';
import AlertModal from '../general/alertModal';
import axios from 'axios';
import Funds from './funds';

function getInitials(name) {
    if (!name) return 'U';
    return name.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase();
}

function ManageUser(props) {
    const { setIsLoading, isCreatigUser, login, is_provider, invitedEmail, newOrganizationId } = props;

    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState(invitedEmail || '');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');
    const navigate = useNavigate();

    const [fundsShow, setFundsShow] = useState(false);
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [showResetPassword] = useState(true);
    const [password, setPassword] = useState('');

    useEffect(() => {
        if (!isCreatigUser) getUser();
    }, []);

    useEffect(() => {
        if (!name || !phone || !email) {
            setMessageType('warning');
            setMessage('Todos los campos son obligatorios');
        } else if (!isValidateEmail(email) && !invitedEmail) {
            setMessageType('warning');
            setMessage('Email no válido');
        } else {
            setMessage('');
        }
    }, [name, email, phone]);

    function isValidateEmail(value) {
        return /^\S+@\S+\.\S+$/.test(value);
    }

    const getUser = () => {
        setIsLoading(true);
        axiosInstance.get('/user')
            .then(response => {
                setName(response.data.name);
                setEmail(response.data.email);
                setPhone(response.data.phone);
                setDepartments(response.data.user_department.map(rel => `${rel.department.id}: ${rel.department.name}`));
                setRoles(response.data.user_role);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                setAlertModalShow(true);
                setAlertModalMsg(error.code === 'ERR_NETWORK' ? 'No hay conexión a internet' : 'Error desconocido: ' + error.message);
            });
    };

    const updateUser = async () => {
        setIsLoading(true);
        axiosInstance.put('/users', { name, email, phone })
            .then(response => {
                setMessageType('success');
                setMessage(response.data.message);
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
                setAlertModalShow(true);
                setAlertModalMsg(
                    error.response.data.message.indexOf('Duplicate') > 0
                        ? 'El email ya está en uso por otro usuario'
                        : error.message
                );
            });
    };

    const createUser = async () => {
        setIsLoading(true);
        ensureCsrfCookie()
            .then(() => axios.post('/register', { name, email, phone, password, password_confirmation: password, newOrganizationId }))
            // El registro deja la sesión abierta: cargar el perfil completo (roles, entidad, módulos)
            // igual que en el arranque, en vez de despachar solo el nombre.
            .then(() => axiosInstance.get('/user'))
            .then(response => {
                setIsLoading(false);
                login(response.data);
                navigate('/main', { replace: true });
            })
            .catch(error => {
                setIsLoading(false);
                setAlertModalShow(true);
                const msg = error?.response?.data?.message || '';
                setAlertModalMsg(
                    msg.indexOf('email') > 0
                        ? 'El email ya está en uso por otro usuario'
                        : (error?.code === 'ERR_NETWORK' ? 'No hay conexión con el servidor' : (msg || error.message))
                );
            });
    };

    const saveUser = (e) => {
        e.preventDefault();
        if (isCreatigUser) createUser(); else updateUser();
    };

    const pageTitle = isCreatigUser ? 'Crear cuenta' : 'Mi perfil';

    return (
        <>
            {/* ── Header ── */}
            <div className="user-profile-header">
                <div className="user-avatar">{getInitials(name)}</div>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 800, fontSize: 18, color: 'var(--abi-text)' }}>
                        {name || pageTitle}
                    </div>
                    {!isCreatigUser && email && (
                        <div style={{ fontSize: 13, color: 'var(--abi-muted)', marginTop: 2 }}>{email}</div>
                    )}
                </div>
                {!isCreatigUser && !is_provider && (
                    <Button variant="outline-primary" size="sm" onClick={() => setFundsShow(true)}>
                        <i className="fa fa-money" /> Ver mis fondos
                    </Button>
                )}
            </div>

            <Form onSubmit={saveUser}>
                {/* ── Datos personales ── */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-user-o" /> Datos personales
                    </div>
                    <div className="order-section-body">
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            <div style={{ flex: 1, minWidth: 200 }}>
                                <Form.Label className="report-field-label">Nombre completo</Form.Label>
                                <Form.Control
                                    type="text" value={name}
                                    placeholder="Nombre completo"
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            {!invitedEmail && (
                                <div style={{ flex: 1, minWidth: 200 }}>
                                    <Form.Label className="report-field-label">Correo electrónico</Form.Label>
                                    <div className="auth-input-wrap">
                                        <i className="fa fa-envelope auth-input-icon" />
                                        <Form.Control
                                            type="email" value={email}
                                            placeholder="correo@entidad.com"
                                            disabled={!isCreatigUser}
                                            readOnly={!!invitedEmail}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}
                            <div style={{ flex: 1, minWidth: 160 }}>
                                <Form.Label className="report-field-label">Teléfono</Form.Label>
                                <div className="auth-input-wrap">
                                    <i className="fa fa-phone auth-input-icon" />
                                    <Form.Control
                                        type="text" value={phone}
                                        placeholder="Teléfono o celular"
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Centros de costo ── */}
                {!isCreatigUser && !is_provider && departments.length > 0 && (
                    <div className="order-section">
                        <div className="order-section-header">
                            <i className="fa fa-building-o" /> Centros de Costo asignados
                        </div>
                        <div className="order-section-body" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                            {departments.map(dep => (
                                <span key={dep} className="dept-chip">{dep}</span>
                            ))}
                        </div>
                    </div>
                )}

                {/* ── Roles ── */}
                {!isCreatigUser && roles.length > 0 && (
                    <div className="order-section">
                        <div className="order-section-header">
                            <i className="fa fa-shield" /> Roles asignados
                        </div>
                        <div className="order-section-body" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                            {roles.map(rol => (
                                <span key={rol.id} className="role-chip">
                                    <i className="fa fa-tag" style={{ fontSize: 10 }} />
                                    {rol.role.description}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {/* ── Alert ── */}
                {message && (
                    <Alert variant={messageType} className="py-2" style={{ fontSize: 13 }}>
                        {message}
                    </Alert>
                )}

                {/* ── Acciones editar ── */}
                {!isCreatigUser && (
                    <div className="order-form-footer">
                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                            <Button as={Link} to="/main" variant="outline-secondary" size="sm">
                                <i className="fa fa-arrow-left" /> Cancelar
                            </Button>
                            <Button variant="primary" type="submit" disabled={!!message} size="sm">
                                <i className="fa fa-save" /> Guardar cambios
                            </Button>
                        </div>
                    </div>
                )}
            </Form>

            {/* ── Contraseña ── */}
            <div style={{ marginTop: 14 }}>
                <ResetPassword
                    isCreatigUser={isCreatigUser}
                    show={showResetPassword}
                    setMessage={setMessage}
                    passwordConfirmed={(val) => setPassword(val)}
                />
            </div>

            {/* ── Acción registrar ── */}
            {isCreatigUser && (
                <div className="order-form-footer" style={{ marginTop: 14 }}>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <Button as={Link} to="/home" variant="outline-secondary" size="sm">
                            Cancelar
                        </Button>
                        <Button
                            variant="primary" size="sm"
                            onClick={saveUser}
                            disabled={!!message || !password}
                        >
                            <i className="fa fa-user-plus" /> Registrarme
                        </Button>
                    </div>
                </div>
            )}

            {!isCreatigUser && <Funds show={fundsShow} setShow={setFundsShow} />}
            <AlertModal show={alertModalShow} setShow={setAlertModalShow} msg={alertModalMsg} />
        </>
    );
}

function mapStateToProps(state) {
    return {
        username: state.username,
        isLoggedIn: state.isLoggedIn,
        isLoading: state.isLoading,
        is_provider: state.is_provider,
    };
}

const mapDispatchToProps = { setIsLoading, login };

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser);
